import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./components/header/header.component";
import { LocaleService } from './services/locale/locale.service';
import { ConfigService } from './services/config/config.service';
import { PmuService } from './services/data/pmu.service';
import { DeviceInfo } from './models/save-bet-options.model';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { environment } from '../environments/environment';
import { GetProviderReqParams } from './models/provider.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'saloon-app';
  subscriptions: Subscription = new Subscription();

  constructor(
    private readonly localeService: LocaleService,
    private readonly configService: ConfigService,
    private readonly pmuService: PmuService) {}

  ngOnInit(): void {
    this.loadData();
    this.initDeviceInfo();
    this.subscriptions.add(
      this.pmuService.refreshAppState.subscribe(res => {
        if (res == true) {
          this.loadData();
        }
      })
    )
  }

  initDeviceInfo() {
    const deviceInfo: DeviceInfo = {
      imei: 359457091016302,
      mode: 'test',
      DT: 2,
      userid: '12345',
      pwd: '1357',
      channel: 3
    }
    this.pmuService.updateBetOptions({deviceInfo});
  }
  async loadData() {
    await this.fetchConfigs();
    this.getActiveGames();
    this.getCashInProviders();
  }

  getCashInProviders() {
     let params: GetProviderReqParams = { type: "CASHIN", anonymous: true, lang: this.localeService.locale.split('')[0] };
    this.pmuService.fetchCashInProviders(params);
  }

  fetchConfigs() {
    this.configService.getSystemConfigs();
  }

  getActiveGames() {
    const date = environment.dev ? null : new Date();
    this.pmuService.getActiveGames(date);
  }
}
